module.exports = __webpack_public_path__ + "static/6-6c327797ad0b769b87b6a9a10e627062.jpg";